import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import routerHistory from '../../routerHistory';
import Logo from '../common/Logo';
import CustomButton from '../common/CustomButton';
import * as accountActions from '../../actions/accountActions';
import { ROUTES } from '../../const';

class Mail extends React.Component {
  constructor(props) {
    super(props);
    this.goToLogin = Mail.goToLogin.bind(this);
  }

  static propTypes = {};

  componentDidMount() {
    const { accountActions } = this.props;
    accountActions.setIndexTransition(false);
  }

  componentWillUnmount() {
    const { accountActions } = this.props;
    accountActions.newPasswordSent(false);
  }

  static goToLogin(e) {
    e.preventDefault();
    routerHistory.push(ROUTES.LOGIN);
  }

  render() {
    return (
      <div className="column xlarge-6 large-8 medium-10 small-12 content align-center">
        <div className="row box background-color-opaque background-color-opaque-opacity align-center">
          <div className="row small-12 align-top">
            <div className="column">
              <div className="column small-12 text-center">
                <Logo customCss="logo-opaque" />
              </div>
              <h4 className="columns medium-12 text-center">{I18n.t('mailPassword.title')}</h4>
              <p className="columns medium-12 text-center p-32-margin">{I18n.t('mailPassword.text')}</p>

              <form onSubmit={this.goToLogin}>
                <div className="column small-12 simple-button-wrapper">
                  <CustomButton
                    id="sendPassMail"
                    className="button secondary small-button"
                    value={I18n.t('common.close')}
                  />
                </div>
              </form>
            </div>
          </div>

          <div className="row align-self-bottom text-center">
            <Link to={ROUTES.LOGIN}>
              <p className="bottom-link"> {I18n.t('common.backToLogin')}</p>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Mail);
